// Filters.js

import React, { useEffect, useState } from "react";
import "./Filters.scss";

const Filters = ({ regions, onFilterChange }) => {
  const [filterRegion, setFilterRegion] = useState("region-all");

  const handleRegionClick = (region) => {
    // Update the state with the new region
    setFilterRegion(region);
    onFilterChange(region);
  };

  return (
    <div className="region-filters">
      <div
        onClick={() => handleRegionClick("region-all")}
        className={`single-region-tab region-all ${
          filterRegion === "region-all" ? "active-region-tab" : ""
        }`}
      >
        All regions
      </div>
      {regions?.map((region, index) => {
        return (
          <div
            key={`region-${region.toLowerCase()}`}
            onClick={() => handleRegionClick(`region-${region?.toLowerCase()}`)}
            className={`single-region-tab region-${region?.toLowerCase()} ${
              filterRegion === `region-${region?.toLowerCase()}`
                ? "active-region-tab"
                : ""
            }`}
          >
            {region}
          </div>
        );
      })}
    </div>
  );
};

export default Filters;
